import axios from "axios";
import { MDBFileUpload } from "mdb-react-file-upload";
import { MDBAlert, MDBBtn, MDBCard, MDBCardBody, MDBInput, MDBSpinner, MDBSwitch, MDBTextArea } from "mdb-react-ui-kit";
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CategoryContext } from "../context/CategoryContext";
import { DomainContext } from "../context/DomainProvider";
import { GeographyContext } from "../context/GeographyProvider";
import { MiscContext } from "../context/MiscProvider";
import { NavbarContext } from "../context/NavProvider";
import { UserProfileContext } from "../context/UserProfileProvider";
import UserMessagesModal from "../messages/UserMessagesModal";
import { fetchIPAddress, getDomainsAndCategories } from "../utils/Common";
import DomainCreateModal from "./DomainCreateModal";
const Domain = ({isCreate, fName }) => {


    const [firmName, setFirmName] = useState('');
    const [name, setName] = useState('');
    const navigate = useNavigate();
    const [type, setType] = useState('');
    const [doingBusinessAs, setDoingBusinessAs] = useState('home');
    const [domainUrl, setDomainUrl] = useState(['URL']);
    const [, setAllowUserCreation] = useState(false);
    const [description, setDescription] = useState(' ');
    const [domain, setDomain] = useState(null);
    const [file, setFile] = useState(null);
    const [isDomainCreateModalOpen, setIsDomainCreateModalOpen] = useState(false);
    const handleIsDomainCreateModalOpenToggle = () => setIsDomainCreateModalOpen(!isDomainCreateModalOpen);
    const { domainId } = useParams();
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
    const [isLoading, setIsLoading] = useState(false);
    const {pageData} = useContext(MiscContext);
    const {selectDomains,setSelectDomains,setGroupedDomainsByDomain,setDomainData,domainData,setDomainImages,setDomainId} = useContext(DomainContext);
    const {setGroupedCategoriesByDomain,setCategoryImages,setSelectCategories} = useContext(CategoryContext);
    const {ipAddress,location,setCountry,setIPAddress} = useContext(GeographyContext);
    const {tokenLoaded} = useContext(UserProfileContext);
    const {setBusiness,isPricing} = useContext(NavbarContext);  
    const [tempDomainId, setTempDomainId] = useState(null);
    const [disableDomain, setDisableDomain] = useState(false);
    const firmFromLocalStorage = localStorage.getItem('FIRM');
    const[userMessages,setUserMessages] = useState([]);
    const getIPAddress = useCallback(() => {
        if(ipAddress){
        return ipAddress || localStorage.getItem('ipAddress');
        }else{
            return fetchIPAddress(setIPAddress)
        }
    },[ipAddress])


    useEffect(() => {
        if (selectDomains?.length === 0) {
            getDomainsAndCategories(firmFromLocalStorage,location,ipAddress,tokenLoaded,setBusiness,setCountry,setSelectCategories,setSelectDomains,setGroupedCategoriesByDomain,setCategoryImages,setGroupedDomainsByDomain,setDomainImages,setDomainId);
            
        }
    }, [domainId,  tokenLoaded,  setSelectCategories, setSelectDomains,  setCategoryImages, setDomainImages]);

    const fetchData = async () => {
        try {
            let response;
            let data;
           
            if (domainId) {
               
                response = await axios.get(`${baseUrl}/domains/${domainId}?ipAddress=${getIPAddress()}`);
                data = response.data;
            } else {
                response = await axios.get(`${baseUrl}/domains?ipAddress=${getIPAddress()}`);
                data = response.data[0];
                setTempDomainId(data.id);
            }


            if (data) {
                setDomain(data);
                if(data.firm===domainId) {
                    setFirmName(data.name);
                    setDisableDomain(true);
                }else{
                    setFirmName( selectDomains.find(dom => dom.value === data.firm)?.text);
                      setDisableDomain(false);
                     
                }
               //setFirmName(data.firm===data.id ? data.name : data.firm);

                setName(data.name);
                setType(data.type);
                setAllowUserCreation(data.allowUserCreation);
                setDoingBusinessAs(data.doingBusinessAs);
                setDomainUrl(data.url);
                setDescription(data.description);
                setDomainData({ 
                    categoryIds: data.categoryIds,
                    entityIds: data.entityIds,
                    users: data.users,
                    addressIds: data.addressIds
                });
                setSelectDomains(prevSelectDomains => {
                   
                    const prevDomains = prevSelectDomains ?? []; 
                    if (!prevDomains?.some(domain => domain.value === data.id)) {
                      return [
                        ...prevDomains,
                        {
                          text: data.name,
                          value: data.id
                        }
                      ];
                    }
                    // If the value already exists, return the previous array without changes
                    return prevDomains;
                  });
                  
            }
          
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    useEffect(() => {
        if (isCreate || !domainData) {
            setDomain(null);
            setFirmName(fName);
            setName('');
            setType('');
            setAllowUserCreation(true);
            setDescription(' ');
            setDomainData({
                categoryIds: [],
                entityIds: [],
                users: [],
                addressIds: []
            });
            return; // Exit here
        }
      
        fetchData();
    }, [baseUrl, domainId, fName, getIPAddress, isCreate, selectDomains, setDomainData, setSelectDomains]); // Effect runs whenever domainId changes
  

    const handleCreateUpdate = async () => {

        if ((firmName || name ) && type && doingBusinessAs ) {
            setIsLoading(true);
            const formData = new FormData();
            let url = isCreate ? `${baseUrl}/domains` : domainId ? `${baseUrl}/domains/${domainId}`: `${baseUrl}/domains/${tempDomainId}?ipAddress=${getIPAddress()}`;
            let method = isCreate ? 'post' : 'put';


            if (file) {
                const renamedFile = new File([file], file.name, { type: file.type });
                formData.append('file', renamedFile);
            }
           // let updatedDomain = { name: disableDomain ? firmName : name , type, description, firm: firmName || (firmFromLocalStorage || domainId)? domainId :tempDomainId, doingBusinessAs: doingBusinessAs, url:domainUrl};
              let updatedDomain = { name: disableDomain ? firmName : name , type, description, firm: firmName, doingBusinessAs: doingBusinessAs,  ...(!isPricing && { url: domainUrl })};
           
            const domainData = new File([JSON.stringify(updatedDomain)], "domain", { type: "application/json" });
            formData.append('domain', domainData);

            try {
                await axios({
                    method: method,
                    url: `${url}`,
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    withCredentials: true,
                }).then((response) => {

//setKey(prevKey => prevKey + 1);••
if (isCreate) {
    // Add new domain
    setSelectDomains(prevSelectDomains => {
        return [...prevSelectDomains, {
            text: response.data.name,
            value: response.data.id
        }];
    });
} else {
    // Update existing domain
    setSelectDomains(prevSelectDomains => {
        return prevSelectDomains.map(domain => {
            if (domain.value === response.data.id) {
                return {
                    ...domain,
                    text: response.data.name,
                };
            }
            return domain;
        });
    });
}


                    setUpdateComplete(true);
                    setAlertVisible(true);
                    setAlertMessage(isCreate ? "Domain Created successfully" : "Domain Updated successfully!");
                  //  isCreate && domainIModelClose()
                    console.log(response.data);
                    setUserMessages(response.data.userMessages);
                    if (response.data.imageIds) {
                        setDomain((prevState) => ({
                            ...prevState,
                            imageIds: [response.data.imageIds]
                        }));
                    }
                });
            } catch (error) {
                setAlertMessage("Domain Update was NOT successful!");
                console.error(error);
            }
            finally {
                if (isCreate) {
                    setName('');
                    setType('');
                    setDescription('');
                    setFile(null)
                }
                setIsLoading(false); // Set loading state to false after API call
            }
        }
    };
    const toggleUploadAlert = () => {

        setTimeout(() => {
            setUpdateComplete(false);
        }, 10000);
        setUpdateComplete(!updateComplete);
    };
    const [alertVisible, setAlertVisible] = useState(false);
    const [updateComplete, setUpdateComplete] = useState(false);
    let [alertMessage, setAlertMessage] = useState("");
    const toggleAlertVisible = () => {
        setAlertVisible(!alertVisible);

    };
    let alertProperties = {};
    let alertIcon = '';
    if (updateComplete) {
        alertProperties = {
            open: true,
            className: 'm-1',
            color: 'success',
            onClick: toggleUploadAlert,
            position: 'center'

        };
        alertIcon = 'fas fa-check-circle me-3';
    } else if (alertVisible) {
        alertProperties = {
            open: true,
            className: 'm-1',
            color: 'success',
            onClick: toggleAlertVisible,
        };
        alertIcon = 'fas fa-check-circle me-3';

    }
    const handleSwitchChange = (e) => {
        setAllowUserCreation(e.target.checked);
      };


    const handleDelete = async () => {
        let deleteId = domain?.id;
        let url = `${baseUrl}/domains/${domain.id}`;

        try {
            const response = await axios.delete(url, {
                headers: {},
                withCredentials: true
            });

            if (response.status === 200) {
                setSelectDomains(prevSelectDomains => {

                    return prevSelectDomains.filter(domain => domain.value !== deleteId);
                });

                const lastDomain = selectDomains[0]?.value;
                // Navigate to last domain
                if (lastDomain) {
                    navigate(`/domain/${lastDomain}`);
                }

                setAlertMessage("Domain has been Deleted!");
                setAlertVisible(true);
            }
        } catch (error) {
            console.error(error);
        } finally {

            setName('');
            setType('');
            setDescription('');
            setFile(null)

        }

    };




    const handleFileChange = (event) => {
        if (event && event.length > 0) {
            let selectedFile = event[0];
            setFile(selectedFile);
        } else {
            setFile(null);
        }
    };
  
    return (
        <section className="mb-2 position-relative grainy-gradient-intro justify-content-center text-center">

                <MDBAlert {...alertProperties} style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 9999, width: 'auto', maxWidth: '90%' }} autohide>
                    <i className={alertIcon}></i>{alertMessage}

                </MDBAlert>
              
            {/* Conditionally render spinner */}
            {isLoading && (
                <MDBSpinner className='me-2' style={{ width: '3rem', height: '3rem' }} color='light'>
                    <span className='visually-hidden'>Loading...</span>
                </MDBSpinner>
            )}
             <UserMessagesModal messages={userMessages } isFromDomain={true}/>
             <section className="mb-2 position-relative grainy-gradient-intro justify-content-center text-center" >

                 
                        <MDBCard  className='text-center rounded mt-3 gy-2 gx-3 align-items-center'>
                            {/* <MDBCardImage cascade style={{ height: '20rem', borderRadius: "12px" }} hover overlay='white-slight' src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/12-col/img%20%281%29.jpg" />
                            <MDBCardOverlay tag="section" cascade className="text-center rounded" style={{ height: '20rem', borderRadius: "12px" }}> */}

                                <MDBCardBody className="text-center" style={{ backgroundColor: "white", borderRadius: "12px" }}>


                                    <form  className='text-center rounded mt-3 gy-2 gx-3 align-items-center'>
                                        {domain?.imageIds?.length > 0 && <img src={domain.imageIds[0]} alt="" className='img-fluid shadow-4 rounded' style={{ height: '20rem', borderRadius: "12px" }} />}
                                        <MDBFileUpload className="mb-4" onChange={handleFileChange} />
                                        <MDBInput
                                            className="mb-4"
                                            label="Firm Name *"
                                            value={firmName}
                                            onChange={(e) => setFirmName(e.target.value)}
                                           // disabled
                                        />


                                       {!disableDomain && <MDBInput
                                            className="mb-4"
                                            label="Domain Name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                          //  disabled={disableDomain}
                                        />}

                                        <MDBInput
                                            className="mb-4"
                                            label="Type *"
                                            value={type}
                                            onChange={(e) => setType(e.target.value)}
                                            
                                        />
                                           <MDBSwitch className="mb-4"
      defaultChecked={pageData?.allowUserCreation} 
      id='isPublicUser' 
      label='Allow this domain to have public user creation?' 
      onChange={handleSwitchChange}
    />


                                       {localStorage.getItem('SUBSCRIPTION') ==='commercial' &&  <MDBInput
                                            className="mb-4 mt-4"
                                            label="DoingBusinessAs"
                                            value={doingBusinessAs}
                                            onChange={(e) => setDoingBusinessAs(e.target.value)}
                                            
                                        />}
                                              {/* <MDBInput
                                            className="mb-4"
                                            label="DomainURL"
                                            value={domainUrl}
                                            onChange={(e) => setDomainUrl(e.target.value)}
                                            
                                        /> */}
                                        <MDBTextArea
                                            rows={4}
                                            className="mb-4 mt-4"
                                            label="Description"
                                            value={description || ""}
                                            onChange={(e) => setDescription(e.target.value)}
                                        />


                                        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>


                                            <MDBBtn
                                                disabled={isLoading || !name || !type  || !doingBusinessAs || ! firmName }
                                                type="button"
                                                className="mb-4 mb-md-0 me-2 responsive-button"
                                                onClick={handleCreateUpdate}
                                            >
                                                {isLoading ? (
                                                    <MDBSpinner size='sm' role='output' tag='span' className='me-2' />
                                                ) : null}
                                                {isCreate ? 'Save' : 'Update'}
                                            </MDBBtn>


                                            {(name === firmName) && !isCreate && (

                                                <MDBBtn type="button" color="success" className="mb-4 mb-md-0 me-2 responsive-button" onClick={handleIsDomainCreateModalOpenToggle}>
                                                    create new domain
                                                </MDBBtn>

                                            )}

                                            {!isCreate && <MDBBtn type="button" color="success" className="mb-4 mb-md-0 me-2 responsive-button" onClick={handleDelete} >
                                                delete
                                            </MDBBtn>}
                                            {/* <MDBBtn type="button" color='dark' size='sm' className="mb-4 mb-md-0 me-2" onClick={handleIsEntityCreateModalOpenToggle}>
                                            Inventory
                                        </MDBBtn> */}

                                        </div>

                                    </form>
                                </MDBCardBody>
                            {/* </MDBCardOverlay> */}
                        </MDBCard>
                
          


            </section>
            {isDomainCreateModalOpen && <DomainCreateModal isDomainCreateModalOpen={isDomainCreateModalOpen} handleIsDomainCreateModalOpenToggle={handleIsDomainCreateModalOpenToggle} firmName={firmName} />}
        </section>

    )
}
Domain.propTypes = {
    tokenLoaded: PropTypes.string,
    isCreate: PropTypes.bool,
    fName: PropTypes.string,
    domainIModelClose: PropTypes.func,

};


export default Domain;
